import { useCallback, useEffect, useRef } from 'react';

export function useDebounceCallback(callback: Function, delay: number = 100, dependencies: any[] = []) {
  const timeoutRef = useRef<any>(null);
  const callbackRef = useRef<Function>(callback);

  useEffect(() => {
    callbackRef.current = callback;
  }, [callback]);

  const debouncedCallback = useCallback((...args: any[]) => {
    // Clear any existing timeout
    if (timeoutRef.current) {
      clearTimeout(timeoutRef.current);
    }

    // Set a new timeout to execute the callback after the delay
    timeoutRef.current = setTimeout(() => {
      callbackRef.current(...args);
    }, delay);
  }, [delay, ...dependencies]); // Keep stable across renders; callback is read from ref.

  // Clean up timeout on unmount
  useEffect(() => {
    return () => {
      if (timeoutRef.current) {
        clearTimeout(timeoutRef.current);
      }
    };
  }, []);

  return debouncedCallback;
}
